export enum OptimizationTarget {
    FASTEST_PAYOFF = 'FASTEST_PAYOFF'
}
